import React from 'react'

const MetaBadge = ({
  primaryText,
  secondaryText,
  icon,
  isLocked = true,
  className = '',
  bgClass,
  tagType = 'unlocked_news_articles',
  primaryTextColorClass = 'text-(--sb-meta-badge-primary-text-color)',
  secondaryTextColorClass = 'text-(--sb-meta-badge-primary-text-color)',
}) => {
  if (!primaryText && !secondaryText) return null

  const screenReaderText = `${primaryText ? primaryText : ''} ${secondaryText ? `, ${secondaryText}` : ''}`

  const bgColor = {
    locked_news_articles: 'bg-(--sb-meta-badge-locked-theme)',
    unlocked_news_articles: 'bg-(--sb-meta-badge-unlocked-theme)',
    event: 'bg-(--sb-meta-badge-event-theme)',
    training: 'bg-(--sb-meta-badge-t-and-d-theme)',
  }

  const secondaryTextColor = {
    locked_news_articles: 'text-(--sb-meta-badge-secondary-text-color)',
    unlocked_news_articles: 'text-(--sb-meta-badge-secondary-text-color)',
    training: 'text-(--sb-meta-badge-primary-text-color)',

    event: 'text-(--sb-meta-badge-primary-text-color)',
  }

  // if bgClass value available then pass it, if not select from the existing colors by the tag type.
  const bgColorClass = bgClass || bgColor[tagType]
  const secondaryTextClass = secondaryTextColor[tagType]

  // Without a primary (tag) pill the badge has no inner white pill to pad against,
  // so use symmetric padding and drop the secondary text's left margin.
  const outerPaddingClass = primaryText ? 'p-[3px] pr-3.5' : 'px-3.5 py-1'

  return (
    <span
      className={`inline-flex items-center rounded-full ${outerPaddingClass} shadow-sm ${bgColorClass} ${className}`}
      role="text"
      aria-label={screenReaderText}
    >
      {/* Inner White Pill */}
      {primaryText && (
        <span
          className={`flex items-center gap-1.5 rounded-full bg-white px-2.5 py-0.5 text-xs font-medium ${primaryTextColorClass}`}
          aria-hidden="true"
        >
          {icon && <span className="flex items-center justify-center shrink-0">{icon}</span>}
          {primaryText}
        </span>
      )}

      {/* Secondary Text (e.g., "3 min") */}
      {secondaryText && (
        <span
          className={`${primaryText ? 'ml-2.5' : ''} text-xs font-medium tracking-wide ${secondaryTextClass}`}
          aria-hidden="true"
        >
          {secondaryText}
        </span>
      )}
    </span>
  )
}

export default MetaBadge
